import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class Carousel extends Vue {
  @Prop({ default: () => [] }) items;
  @Prop({ default: null }) selectedItem;
  @Prop({ default: "id" }) identifierKey;

  get getSelectedItemIndex() {
    return this.items.findIndex(
      (item) => item[this.identifierKey] === this.selectedItem[this.identifierKey]
    );
  }
}
